import { CAMPAIGN } from 'pages/MyAccount/services/actions/campaignActions';

export const campaignInitialState = {
  premiumStartDate: '1970-01-01T00:00:00Z',
  premiumEndDate: '2020-01-01T00:00:00Z',
  startDate: '1970-01-01T00:00:00Z',
  endDate: '2020-01-01T00:00:00Z',
  fetchingCampaign: true,
  campaignName: null,
  campaignId: null,
  campaignStatus: null,
  windowType: null,
  userAccess: false,
  sponsoredThreshold: 0,
  campaignError: false,
  bannerTitle: '',
  bannerParagraph: '',
  bannerBackgroundColor: '',
  bannerFAQUrl: '',
  bannerDesktopImageUrl: '',
};

export function campaignReducer(state = campaignInitialState, action) {
  switch (action.type) {
    case CAMPAIGN.REQUEST_ALL_DATA: {
      return {
        ...state,
        fetchingCampaign: true,
      };
    }
    case CAMPAIGN.RECEIVE_CAMPAIGN: {
      const {
        premiumStartDate,
        premiumEndDate,
        startDate,
        endDate,
        id,
        name,
        campaignStatus,
        campaignWindow,
        windowType,
        userAccess,
        sponsoredThreshold,
        bannerTitle,
        bannerParagraph,
        bannerBackgroundColor,
        bannerFAQUrl,
        bannerDesktopImageUrl,
      } = action.payload;
      return {
        ...state,
        premiumStartDate,
        premiumEndDate,
        startDate,
        endDate,
        userAccess,
        campaignStatus: campaignStatus.toLowerCase(),
        campaignWindow,
        windowType: windowType.toLowerCase(),
        fetchingCampaign: false,
        campaignId: id,
        campaignName: name,
        sponsoredThreshold,
        bannerTitle,
        bannerParagraph,
        bannerBackgroundColor,
        bannerFAQUrl,
        bannerDesktopImageUrl,
      };
    }
    case CAMPAIGN.RECEIVE_CAMPAIGN_ERROR: {
      return {
        ...state,
        campaignError: true,
      };
    }
    default: {
      return state;
    }
  }
}
